import { notification } from 'clad';

const notificationPopUp = (type, message, description) => {
    notification[type]({
        message: message,
        description: description,
        placement: 'bottomRight'
    });
};

export default notificationPopUp;
